import type {
  AutoPostConfig,
  AutoPostProfile,
  CashAppOverview,
  CashAppSettings,
  RemittanceRequestPreview,
} from '../models';
import { Resource } from './resource';
import { EmailTemplateQueryParams } from '../query';

export class CashApp extends Resource {
  resourcePath = 'v1/cash-app';

  async retrieveOverview(): Promise<CashAppOverview> {
    const response = await this.api.get(this.path('overview'));

    return response.data;
  }

  async retrieveSettings(): Promise<CashAppSettings> {
    const response = await this.api.get(this.path('settings'));

    return response.data;
  }

  async updateSettings(settings: Partial<CashAppSettings>): Promise<CashAppSettings> {
    const response = await this.api.post(this.path('settings'), {
      data: settings,
    });

    return response.data;
  }

  async getAutoPostConfig(): Promise<AutoPostConfig> {
    const response = await this.api.get('/v2/cash-app/auto-post/config');

    return response.data;
  }

  async updateAutoPostConfig(config: Partial<AutoPostConfig>): Promise<AutoPostConfig> {
    const response = await this.api.patch('/v2/cash-app/auto-post/config', { data: config });

    return response.data;
  }

  async getAutoPostProfiles(): Promise<AutoPostProfile[]> {
    const response = await this.api.get('/v2/cash-app/auto-post/profiles');

    return response.data;
  }

  async sendRemittanceRequest(data: {
    bank_transaction_id: string;
    partner_id: string;
    subject?: string;
    body?: string;
    email_sender_id?: string;
    recipient_email?: string;
  }): Promise<any> {
    const response = await this.api.post('/v2/cash-app/outreach/remittance-request', {
      data,
    });
    return response.data;
  }

  async previewRemittanceRequest(
    transactionId: string,
    partnerId: string,
  ): Promise<RemittanceRequestPreview> {
    const response = await this.api.get('/v2/cash-app/outreach/remittance-request/preview', {
      params: {
        bank_transaction_id: transactionId,
        partner_id: partnerId,
      },
    });
    return response.data;
  }
}
